export class GallbladderCalculations {
    update(){

    }
}


// WEBPACK FOOTER //
// ./src/forms/Gallbladder01/Calculations/Gallbladder-Calculations.js